import { useCallback, useEffect, useRef } from 'react';

const UploadButton = ({ onFile }: { onFile: (file?: File) => void }) => {
  const fileRef = useRef<HTMLInputElement>(null);

  const onInputChange = useCallback(
    (event: { target: HTMLInputElement }) => {
      if (!event.target.files || event.target.files.length === 0) {
        return;
      }

      onFile?.(event.target.files[0]);
    },
    [onFile]
  );

  useEffect(() => {
    onFile(undefined);
  }, [onFile]);

  return (
    <>
      <button
        className="side-panel-action-button edit-map-icon"
        onClick={() => fileRef.current?.click()}
      >
        Edit map icon
      </button>
      <input
        className="side-panel-action-button edit-map-icon"
        type="file"
        accept="image/png, image/jpeg"
        onChange={onInputChange}
        ref={fileRef}
        hidden
      />
    </>
  );
};

export default UploadButton;
